import { produce } from "immer";
const defaultState = {
    earningsLoading: false,
    earnings: [],
    activeTab: "all",
    paymentsLoading: false,
    payments: [],

}
const earningReducer = (
    state = defaultState,
    action
) => {
    switch (action.type) {
        case "SET_ACTIVE_TAB_EARNINGS":
            state = {
                ...state,
                activeTab: action.payload,
            };
            break;
        case "GET_EARNINGS_REQUEST":
            state = {
                ...state,
                earningsLoading: defaultState.earningsLoading,
                earnings: defaultState.earnings,
            };
            break;
        case "GET_EARNINGS_SUCCESS":
            state = {
                ...state,
                earningsLoading: false,
                earnings: action.payload,
            };
            break;
        case "GET_EARNINGS_FAILURE":
            state = {
                ...state,
                earningsLoading: defaultState.earningsLoading,
                earnings: defaultState.earnings,
            };
            break;

    }
        return state;

}
export default earningReducer;